module.exports = __webpack_public_path__ + "images/compass-44dc65c3edd2a5d6454d623bff990176.jpg";